export default __webpack_public_path__ + "static/1-aaacb4ca70c7d04e2aef405025160610.jpeg";